/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import { Container, Modal, Grid, Button } from 'semantic-ui-react';
import getImageUrl from 'iovisit-theme/components/Blocks/Listing/Slider/getImageUrl';
import { UniversalLink } from '@plone/volto/components';
import {
  SliderWrapper,
  VariationWrapper,
  When,
  ContentTypeIcon,
  Icon,
  ListingSliderImage,
  ListingSliderPreviewImage,
  ListingSliderPreviewImageMore,
} from 'iovisit-theme/components';

const messages = defineMessages({
  read_more: { id: 'Per approfondire', defaultMessage: 'Per approfondire' },
  nextImage: {
    id: 'next_image',
    defaultMessage: 'Passa ad immagine successiva',
  },
  prevImage: {
    id: 'prev_image',
    defaultMessage: "Torna all'immagine precedente",
  },
  close_modal: {
    id: 'close_modal',
    defaultMessage: 'Chiudi la modale',
  },
});

const Slider = (data) => {
  const intl = useIntl();
  const [previewImage, setPreviewImage] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(null);

  const {
    items,
    size = 'l',
    full_width = false,
    show_item_title = true,
    show_icon = false,
    show_thematic_area = true,
    show_item_description = false,
    show_detail_link = true,
    square_images = false,
    slidesToShow = 1,
  } = data;

  const imageSize = slidesToShow > 1 ? 'gallery' : 'leadimage';

  function carouselModal(direction) {
    // check current index
    let checkIndex;
    if (direction === 'left') {
      if (previewIndex === 0) {
        checkIndex = data.items.length - 1;
      } else {
        checkIndex = previewIndex - 1;
      }
    } else {
      if (previewIndex === data.items.length - 1) {
        checkIndex = 0;
      } else {
        checkIndex = previewIndex + 1;
      }
    }
    const item = data.items[checkIndex];

    setPreviewImage(getImageUrl(item, 'leadimage'));
    setPreviewIndex(checkIndex);
  }

  const leftButtonRef = React.useRef();
  const rightButtonRef = React.useRef();
  const modalCloseRef = React.useRef();

  const refIsFocused = (ref) => {
    return document.activeElement === ref.current?.ref.current;
  };

  useEffect(() => {
    if (
      previewImage != null &&
      !refIsFocused(leftButtonRef) &&
      !refIsFocused(rightButtonRef)
    ) {
      leftButtonRef.current.focus();
    }
  }, [previewImage]);

  return (
    <VariationWrapper {...data} variation="slider">
      <div
        className={`size-${size} ${full_width ? 'full-width' : ''} ${
          square_images ? 'square_images' : ''
        } ${items?.length < slidesToShow ? 'width-for-' + items?.length : ''}`}
      >
        <SliderWrapper
          {...data}
          slidesToShowOnMobile={square_images ? 2 : 1}
          n_items={items?.length}
        >
          {data.items.map((slide, index) => {
            const previewImageUrl = getImageUrl(slide, 'leadimage');

            return (
              <div className="single-slide-wrapper" key={index}>
                <div
                  className={cx('bg-wrapper', {
                    'preview-image': slidesToShow > 1,
                  })}
                  onClick={(e) => {
                    if (slidesToShow > 1) {
                      setPreviewImage(previewImageUrl);
                      setPreviewIndex(index);
                    }
                  }}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      //Enter
                      if (slidesToShow > 1) {
                        setPreviewImage(previewImageUrl);
                        setPreviewIndex(index);
                      }
                    }
                  }}
                  role="button"
                  tabIndex={index}
                >
                  <ListingSliderImage
                    item={slide}
                    size={imageSize}
                    role="presentation"
                  />
                </div>
                {(show_item_title ||
                  show_item_description ||
                  show_detail_link) && (
                  <div className="text-overlay">
                    <Container>
                      <div className="text-overlay-content">
                        <div>
                          <div
                            className={cx('header-slide', {
                              'show-icon': show_icon,
                            })}
                          >
                            {show_icon && (
                              <div className="icon-slide">
                                <ContentTypeIcon item={slide} />
                              </div>
                            )}

                            {show_thematic_area && slide.thematic_area && (
                              <span className="thematic-area-slide">
                                {slide.thematic_area}
                              </span>
                            )}
                          </div>

                          {show_item_title && (
                            <div className="title">{slide.title}</div>
                          )}

                          {(slide.start || slide.end) && (
                            <When
                              start={slide.start}
                              end={slide.end}
                              whole_day={slide.whole_day}
                              open_end={slide.open_end}
                              show_times={false}
                              className="dates"
                            />
                          )}

                          {show_item_description && slide.description && (
                            <div className="description">
                              {slide.description}
                            </div>
                          )}
                        </div>

                        {show_detail_link && (
                          <div className="link">
                            <UniversalLink item={slide}>
                              {intl.formatMessage(messages.read_more)}
                            </UniversalLink>
                          </div>
                        )}
                      </div>
                    </Container>
                  </div>
                )}
              </div>
            );
          })}
        </SliderWrapper>

        <Modal
          id="modalGallery"
          closeIcon={
            <button
              ref={modalCloseRef}
              className="close"
              title={intl.formatMessage(messages.close_modal)}
            >
              <Icon prefix="fa" icon="times" className="close icon" />
            </button>
          }
          closeOnEscape={true}
          onClose={() => {
            setPreviewImage(null);
            setPreviewIndex(null);
          }}
          open={previewImage != null}
          onKeyUp={(e) => {
            if (e.keyCode === 37) {
              //arrow-left
              carouselModal('left');
            }
            if (e.keyCode === 39) {
              //arrow-right
              carouselModal('right');
            }
          }}
          onKeyDown={(e) => {
            if (e.keyCode === 9) {
              //tab

              if (refIsFocused(rightButtonRef)) {
                e.preventDefault();
                modalCloseRef.current.focus();
              }
            }
          }}
          size="large"
        >
          <Modal.Content>
            <div className="preview-image-modal">
              <Grid.Row>
                <Grid.Column>
                  <Button
                    icon
                    onClick={() => carouselModal('left')}
                    title={intl.formatMessage(messages.prevImage)}
                    className="arrow-image arrow-left"
                    ref={leftButtonRef}
                  >
                    <Icon prefix="fa" icon="chevron-left" className="icon" />
                  </Button>
                </Grid.Column>
                <Grid.Column>
                  <div className="preview-image-wrapper">
                    {previewImage && (
                      <img
                        alt=""
                        role="presentation"
                        src={previewImage}
                        loading="lazy"
                      />
                    )}
                    <ListingSliderPreviewImageMore
                      item={data.items?.[previewIndex]}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <Button
                    icon
                    onClick={() => carouselModal('right')}
                    title={intl.formatMessage(messages.nextImage)}
                    className="arrow-image arrow-right"
                    ref={rightButtonRef}
                  >
                    <Icon prefix="fa" icon="chevron-right" className="icon" />
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    </VariationWrapper>
  );
};

export default Slider;
